import {
  Utensils, Wine, Users, Zap, Home, Wrench, ShoppingCart, Truck,
  Megaphone, Receipt, Package, CreditCard, Landmark, Sparkles,
  Droplets, Flame, Coffee, Hammer, Shield, MoreHorizontal, Tag,
} from "lucide-react";

// Icone selezionabili per le tipologie di uscita (nome -> componente lucide)
export const TIPOLOGIA_ICONS = {
  utensils: Utensils,
  wine: Wine,
  coffee: Coffee,
  users: Users,
  zap: Zap,
  flame: Flame,
  droplets: Droplets,
  home: Home,
  wrench: Wrench,
  hammer: Hammer,
  cart: ShoppingCart,
  truck: Truck,
  megaphone: Megaphone,
  receipt: Receipt,
  package: Package,
  card: CreditCard,
  bank: Landmark,
  shield: Shield,
  sparkles: Sparkles,
  more: MoreHorizontal,
};

export const TIPOLOGIA_ICON_OPTIONS = Object.keys(TIPOLOGIA_ICONS);

// Palette colori consigliata per le tipologie
export const TIPOLOGIA_COLORS = [
  "#ef4444", "#f97316", "#f59e0b", "#eab308", "#84cc16", "#22c55e",
  "#14b8a6", "#06b6d4", "#3b82f6", "#6366f1", "#8b5cf6", "#a855f7",
  "#ec4899", "#f43f5e", "#78716c", "#64748b",
];

// Palette di fallback deterministica (per tipologie senza colore assegnato)
const FALLBACK = ["#f97316", "#eab308", "#84cc16", "#14b8a6", "#06b6d4", "#3b82f6", "#8b5cf6", "#ec4899", "#f43f5e", "#a855f7"];

export const tipologiaColor = (tip, index = 0) =>
  (tip && tip.colore) || FALLBACK[index % FALLBACK.length];

// Ritorna il componente icona per un nome, con fallback su Tag
export const TipologiaIcon = ({ name, ...props }) => {
  const Icon = (name && TIPOLOGIA_ICONS[name]) || Tag;
  return <Icon {...props} />;
};
